import { render, staticRenderFns } from "./MySwiperSlide.vue?vue&type=template&id=2fcaa24b&scoped=true&"
var script = {}
import style0 from "./MySwiperSlide.vue?vue&type=style&index=0&id=2fcaa24b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcaa24b",
  null
  
)

export default component.exports